export default {
  flowsDefinitions: state => state.flowsDefinitions,
  flowsDefinitionsUI: state => state.flowsDefinitionsUI,
  flows: state => state.flows,
  flowsMeta: state => state.flowsMeta,
  flowData: state => state.flowData,
  errorUpdatingFlow: state => state.errorUpdatingFlow,
  updatingFlow: state => state.updatingFlow,
  blocksCount: state => state.blocksCount,
  toggleElement: state => state.toggleElement,
};
